import React from 'react'

import { useRequest } from '../hooks/request'
import {
  internshipEdit,
  internshipEditPath,
  internshipGet,
  internshipTrainees,
  internshipTraineesPath,
} from '../requests/internship'
import { PATHS } from '../constants/paths'
import { useUser } from '../data/UserContext'
import { ROLES_BO_EVAL } from '../constants/roles'
import { hasRole } from '../utils/hasRole'

import { PageTitle } from './common/PageTitle'
import { IntershipForm } from './IntershipForm'
import { ItemLoader } from './ItemLoader'

const canEdit = ({ user }) => hasRole(user, ROLES_BO_EVAL) || user.isInternshipDirector

export const InternshipEdit = ItemLoader({
  request: internshipGet,
  pageTitle: (
    <PageTitle tradId="internshipView" backLink={PATHS.INTERNSHIP_LIST} backLinkTrad="internshipList" />
  ),
})(({ getRequest }) => {
  const { user } = useUser()
  const edit = canEdit({ user })
  const internshipUpdateRequest = useRequest({
    request: edit ? internshipEdit : internshipTrainees,
    handler: (p) => p.then((data) => getRequest.setData({ data })),
  })

  const saveSuccess = internshipUpdateRequest.state.success

  const initialValues = getRequest.state.data
  if (initialValues.chief === null) {
    delete initialValues.chiefId
  }
  const path = edit ? internshipEditPath : internshipTraineesPath

  return (
    <>
      <IntershipForm
        initialValues={initialValues}
        onSubmit={internshipUpdateRequest.fetch}
        path={path}
        saveSuccess={saveSuccess}
        loading={internshipUpdateRequest.state.loading}
      />
    </>
  )
})
